import DropDownBar from "../../../reusableUi/DropDownBar";
import BurgerMenu from "../../../reusableUi/BurgerMenu";
import image from "../pictures/why-choose-us-plumber.webp";
import emergencyImg from "../pictures/emergency-plumbing.webp";
import showerImg from "../pictures/shower-head-repair.webp";
import heaterImg from "../pictures/water-heater-services.webp";
import leakImg from "../pictures/leak-detection-repair.webp";
import toiletImg from "../pictures/toilet-fixture-repair.webp";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { useState, useEffect, useRef } from "react";
import Footer from "../../../reusableUi/Footer";
import ScrollableNavs from "../../../reusableUi/ScrollableNavs";
import WhyChooseUs from "../../HomePage/components/WhyChooseUs";
import Reviews from "../../HomePage/components/Reviews";
import FAQs from "../../HomePage/components/FAQs";
import { Wrench, Phone, Mail, ArrowLeft, PhoneCall, ClipboardList, Hammer, BadgeCheck, CheckCircle } from "lucide-react";
import CTASection from "../../../reusableUi/CTA";
import Process from "../../../reusableUi/Process";

const data = [
  {
    title: "Emergency Plumbing",
    description:
      "Our 24/7 emergency plumbing service provides rapid response for urgent issues like major leaks to prevent damage and restore your plumbing fast.",
    slug: "emergency-plumbing",
    metaDesc:
      "Emergency Plumbing in Chicago. Our 24/7 emergency plumbing service provides rapid response for urgent issues like major leaks to prevent damage and restore your plumbing fast.",
    benefits: [
      {
        title: "24/7 Emergency Response",
        desc: "Available day and night to handle urgent plumbing problems before they cause serious property damage.",
      },
      {
        title: "Fast Arrival",
        desc: "Rapid dispatch to reach your location quickly and stop leaks or flooding immediately.",
      },
      {
        title: "Licensed Plumbers",
        desc: "Certified professionals trained to safely resolve high-pressure emergency plumbing situations.",
      },
      {
        title: "Upfront Pricing",
        desc: "Clear pricing provided before work begins, even during urgent service calls.",
      },
    ],
    reviews: [
      { text: "They fixed the leakage in my faucet fast and professionally.", name: "Alex, Chicago", job: "Homeowner", rating: 5 },
      { text: "Quick response and great service.", name: "Sarah, Chicago", job: "Tenant", rating: 4 },
      { text: "Solved the issue right away.", name: "John, Chicago", job: "Landlord", rating: 5 },
      { text: "Arrived late at night and handled it perfectly.", name: "Michael, Chicago", job: "Homeowner", rating: 5 },
    ],
    pic: emergencyImg,
    faqs: [
      { question: "How quickly can you respond to emergency plumbing issues?", answer: "Our emergency team is available 24/7 and responds as quickly as possible. In many cases, we arrive within the same hour to stop leaks, limit damage, and restore plumbing safely." },
      { question: "What problems are considered plumbing emergencies?", answer: "Flooding, major leaks, overflowing toilets, and complete water loss are all emergencies that require immediate professional attention." },
      { question: "Will I receive pricing before repairs begin?", answer: "Yes. We always provide clear upfront estimates and explain repair options so you know exactly what to expect before any work starts." },
    ],
  },
  {
    title: "Shower Head Repair",
    description: "We repair and replace shower heads to restore strong water flow while fixing leaks, blockages, and worn connections quickly and cleanly.",
    slug: "shower-head-repair",
    metaDesc: "Shower Head Repair in Chicago. We repair and replace shower heads to restore strong water flow while fixing leaks, blockages, and worn connections quickly and cleanly.",
    benefits: [
      { title: "Quick Service", desc: "Efficient repair and replacement completed in a single visit." },
      { title: "Improved Water Pressure", desc: "Removal of buildup and faulty components to restore strong and consistent flow." },
      { title: "Affordable Pricing", desc: "Cost-effective repair solutions without unnecessary replacements." },
      { title: "Professional Tools", desc: "Proper equipment used to ensure clean installation and prevent damage." },
    ],
    reviews: [
      { text: "Shower works like new now.", name: "Maya, Chicago", job: "Tenant", rating: 4 },
      { text: "Fixed the clog in minutes.", name: "Omar, Chicago", job: "Homeowner", rating: 5 },
      { text: "Very clean and professional.", name: "Leah, Chicago", job: "Manager", rating: 5 },
      { text: "Pressure improved instantly.", name: "Daniel, Chicago", job: "Homeowner", rating: 4 },
    ],
    pic: showerImg,
    faqs: [
      { question: "What shower head issues do you repair?", answer: "We fix leaks, mineral buildup, low pressure, broken fittings, and worn internal parts. When replacement makes more sense, we install new units for improved performance." },
      { question: "Can weak water pressure in the shower be improved?", answer: "Yes. Low pressure is commonly caused by clogs, sediment buildup, or faulty components, all of which we can diagnose and fix effectively." },
      { question: "How long does a shower head repair usually take?", answer: "Most repairs are completed in one visit and typically take less than an hour depending on the problem." },
    ],
  },
  {
    title: "Water Heater Services",
    description: "We install, repair, and maintain water heaters to keep hot water reliable and energy efficient in your home or business.",
    slug: "water-heater-services",
    metaDesc: "Water Heater Services in Chicago. We install, repair, and maintain water heaters to keep hot water reliable and energy efficient in your home or business.",
    benefits: [
      { title: "Reliable Hot Water", desc: "Consistent and dependable hot water supply for daily residential or commercial use." },
      { title: "Energy Efficiency", desc: "Optimized systems that reduce energy consumption and lower utility costs." },
      { title: "All Brands Serviced", desc: "Experienced with major manufacturers and both tank and tankless systems." },
      { title: "Same-Day Service", desc: "Fast scheduling to restore hot water without extended downtime." },
    ],
    reviews: [
      { text: "Installed fast and works great.", name: "Liam, Chicago", job: "Homeowner", rating: 5 },
      { text: "Very friendly technicians.", name: "Sophia, Chicago", job: "Tenant", rating: 5 },
      { text: "Repaired my old heater easily.", name: "Zara, Chicago", job: "Landlord", rating: 4 },
      { text: "Hot water same day.", name: "Andrew, Chicago", job: "Homeowner", rating: 5 },
    ],
    pic: heaterImg,
    faqs: [
      { question: "What types of water heaters do you service?", answer: "We service traditional tank systems and modern tankless water heaters from all major manufacturers." },
      { question: "How long does installation usually take?", answer: "Most water heater installations are completed within the same day so you can quickly return to normal use." },
      { question: "Should I repair or replace an older heater?", answer: "We assess the unit's condition and provide honest recommendations based on cost, efficiency, and reliability." },
    ],
  },
  {
    title: "Leak Detection & Repair",
    description: "We locate hidden leaks using advanced tools and repair them quickly before they cause serious structural damage.",
    slug: "leak-detection-repair",
    metaDesc: "Leak Detection & Repair in Chicago. We locate hidden leaks using advanced tools and repair them quickly before they cause serious structural damage.",
    benefits: [
      { title: "Precise Detection", desc: "Advanced equipment used to accurately locate hidden leaks without unnecessary wall or floor damage." },
      { title: "No Unnecessary Damage", desc: "Targeted detection methods reduce invasive demolition during diagnosis." },
      { title: "Lower Water Bills", desc: "Stopping leaks quickly prevents wasted water and rising utility costs." },
      { title: "Fast Repairs", desc: "Immediate repair after detection to prevent further structural or mold damage." },
    ],
    reviews: [
      { text: "Found a hidden leak quickly.", name: "Aisha, Chicago", job: "Homeowner", rating: 5 },
      { text: "Very precise service.", name: "Daniel, Chicago", job: "Supervisor", rating: 4 },
      { text: "Quick and clean fix.", name: "Fatima, Chicago", job: "Tenant", rating: 5 },
      { text: "Solved what others couldn't.", name: "Thomas, Chicago", job: "Homeowner", rating: 5 },
    ],
    pic: leakImg,
    faqs: [
      { question: "How are hidden leaks detected?", answer: "We use specialized equipment such as moisture sensors and acoustic tools to locate leaks without damaging walls or floors." },
      { question: "Can small leaks cause serious problems?", answer: "Yes. Over time even minor leaks can lead to mold growth, structural damage, and higher water bills." },
      { question: "Do you repair leaks after detection?", answer: "Yes. Once located, we repair the leak immediately whenever possible to prevent further damage." },
    ],
  },
  {
    title: "Toilet & Fixture Repair",
    description: "We repair leaking toilets, broken sinks, faucets, and plumbing fixtures to restore normal use quickly and affordably.",
    slug: "toilet-fixture-repair",
    metaDesc: "Toilet & Fixture Repair in Chicago. We repair leaking toilets, broken sinks, faucets, and plumbing fixtures to restore normal use quickly and affordably.",
    benefits: [
      { title: "Fast Repairs", desc: "Quick diagnosis and repair to restore normal bathroom and kitchen function." },
      { title: "Leak Elimination", desc: "Permanent solutions that stop running toilets and dripping fixtures." },
      { title: "Affordable Service", desc: "Cost-effective repairs without unnecessary part replacements." },
      { title: "One-Visit Solutions", desc: "Most toilet and fixture problems resolved in a single appointment." },
    ],
    reviews: [
      { text: "Toilet fixed perfectly.", name: "Ravi, Chicago", job: "Tenant", rating: 5 },
      { text: "Quick and friendly team.", name: "Emily, Chicago", job: "Homeowner", rating: 4 },
      { text: "Multiple fixtures repaired.", name: "Jamal, Chicago", job: "Manager", rating: 5 },
      { text: "Everything works now.", name: "Kevin, Chicago", job: "Homeowner", rating: 5 },
    ],
    pic: toiletImg,
    faqs: [
      { question: "What toilet problems do you repair?", answer: "We fix running toilets, constant clogs, weak flushing, leaking bases, and broken internal components." },
      { question: "Can damaged fixtures be replaced?", answer: "Yes. We repair or replace sinks, faucets, and other fixtures depending on their condition and your preference." },
      { question: "How fast are most repairs completed?", answer: "Most fixture repairs are completed within one visit, usually under an hour." },
    ],
  },
];

const processSteps = [
  {
    icon: PhoneCall,
    title: "Call or Contact Us",
    desc: "Reach out by phone or contact form. We'll ask a few quick questions to understand the issue and schedule your appointment.",
  },
  {
    icon: ClipboardList,
    title: "Diagnosis & Estimate",
    desc: "A licensed plumber arrives, diagnoses the problem, and gives you a clear upfront estimate — no hidden fees, no surprises.",
  },
  {
    icon: Hammer,
    title: "Expert Repair",
    desc: "We get straight to work using professional tools and quality parts, completing most jobs in a single visit.",
  },
  {
    icon: BadgeCheck,
    title: "Quality Sign-Off",
    desc: "Before we leave, we test everything to make sure the repair is solid and you're completely satisfied with the result.",
  },
];

export default function ServicesInfo() {
  const { slug } = useParams();
  const service = data.find((item) => item.slug === slug);
  const navigate = useNavigate();

  useEffect(() => {
    if (!service) return;
    document.title = `${service.title} | Chicago Plumbing Services`;
      const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", service.metaDesc);
  }, [service]);

  const upSection = useRef(null);
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <div className="space-y-26">
      <header className="max-w-[90%] mx-auto xl:max-w-6xl">

        {/* Mobile nav */}
        <nav className="md:hidden flex items-center justify-between py-5 mb-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <BurgerMenu />
        </nav>

        {/* Tablet nav */}
        <nav className="hidden max-lg:md:flex items-center justify-between py-5 mb-6">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-8">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="text-sm font-bold bg-blue-600 hover:bg-blue-700 transition-colors px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25">
                Contact Us
              </a>
            </li>
          </ul>
        </nav>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center justify-between py-6 mb-12">
          <Link to="/" className="flex items-center gap-3">
            <span className="w-9 h-9 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-2xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-10">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <Link to="/locations" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">Service Areas</Link>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="flex items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
                <Mail className="w-4 h-4" /> Contact
              </a>
            </li>
          </ul>
        </nav>

        <DropDownBar upSectionRef={upSection} />

        {/* Hero */}
        <div ref={upSection} className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center pb-24">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                Same-Day Service Available
              </div>
              <h1 className="font-black text-gray-900 text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                {service.title} <span className="text-blue-600">Service</span>
              </h1>
              <p className="text-gray-500 text-lg leading-relaxed max-w-md">
                {service.description} Call today for fast, same-day service in Chicago or contact us for more information.
              </p>
            </div>
            <PrimaryButton />
          </div>

          <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-0">
            <div aria-hidden="true" className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10" />
            <img
              src={service.pic}
              className="w-full rounded-3xl shadow-2xl object-cover max-h-[520px]"
              alt="A plumber fixing a kitchen faucet."
            />
          </div>
        </div>

      </header>

      <main className="max-w-[90%] mx-auto space-y-26 xl:max-w-6xl">
        <section><WhyChooseUs /></section>
{/* Benefits */}
{/* Benefits */}
<section>
  <div className="space-y-4 mb-10">
    <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
      What you get
    </div>
    <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
      {service.title} Benefits
    </h2>
    <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
      Every job is backed by our commitment to quality, transparency, and lasting results.
    </p>
  </div>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-gray-100 rounded-2xl overflow-hidden">
    {service.benefits.map((benefit, i) => (
  <div key={i} className="bg-white p-7 flex flex-col gap-4 group border border-gray-100 rounded-2xl hover:border-blue-500 hover:shadow-md hover:shadow-blue-500/10 duration-300 transition-all">
    <div className="flex items-center justify-between">
      <div className="w-11 h-11 bg-blue-50 group-hover:bg-blue-100 transition-colors duration-300 rounded-xl flex items-center justify-center">
        <CheckCircle className="w-5 h-5 text-blue-600" />
      </div>
      <span className="text-4xl font-black text-gray-100 group-hover:text-blue-100 transition-colors duration-300 select-none leading-none">
        {String(i + 1).padStart(2, "0")}
      </span>
    </div>
    <div>
      <h3 className="font-bold text-gray-900 text-base mb-1.5 group-hover:text-blue-600 transition-colors duration-300">{benefit.title}</h3>
      <p className="text-gray-400 text-sm leading-relaxed">{benefit.desc}</p>
    </div>
  </div>
))}
  </div>
</section>

<section><Process /></section>
        <section><Reviews /></section>
        <section><FAQs /></section>
        <section><CTASection /></section>
      </main>

      <footer><Footer /></footer>
    </div>
  );
}